import React, { Fragment, PureComponent, useCallback, useContext, useEffect, useState } from 'react';
import { NavLink, Route, Switch, useHistory, useLocation, useParams } from "react-router-dom";
// import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';
// import { CategoricalChartState } from "recharts/types/chart/types";
// import { MdInfoOutline } from 'react-icons/md';

import ReactApexChart from "react-apexcharts";

import { ulid } from 'ulid';

import { Loading } from "../../Shared";

// import ReactMinimalPieChart from "react-minimal-pie-chart";

// import Circle from "react-circle";

import { ActionButton, BaseButton, Button, Callout, ChoiceGroup, DefaultButton, Dialog, DialogFooter, DialogType, DirectionalHint, Dropdown, DropdownMenuItemType, FontWeights, IChoiceGroupOption, Icon, IDropdownOption, Label, mergeStyleSets, Panel, PanelType, PrimaryButton, Shimmer, Spinner, SpinnerSize, TextField, Toggle, TooltipHost, Text, Link, Stack } from "office-ui-fabric-react";

import { apiGet, apiPost } from "../../../helpers-sales";





import SortableList, { SortableItem } from "react-easy-sort";

import { arrayMoveImmutable } from "array-move";





import { WsDecodeBoardInterface, WsDecodeMetric, WsDecodeSource } from '../../../../../core/src/interfaces';






import { BiInfoCircle } from "react-icons/bi";








import { icon } from "@fortawesome/fontawesome-svg-core";

import { WsBreadcrumb } from "./DecodePage";

import { defaultValue, isNumeric } from "../../../helpers";

import { WsDecodeFieldFinder, WsDecodeLinkBoardDialog } from "./DecodeMetrics";

import { WsDecodeScoreView, WsDecodeClassification, WsDecodeMeasurement, WsSalesOrganizationType } from "../../../enums";








import { generateDataValueList, getBoardScorePercent, getLabelList, getMetricScore, getMetricScoreBasedOnFilter, getMetricStatistic, getMetricStatisticValue, getMetricValueString, getMetricValueStringPercent, getNumericValueBasedOnFilter, getScoreValue, WsDecodeCard, WsMetricStatistic } from "./decode-data";

import { WsWheelRecharts, WsWheelItem } from "./WheelRecharts";






import { WsDecodeMetricDialog } from "./DecodeMetricDialog";

import { WsDecodeContext } from "../DecodeContext";

import { WsDecodeFilters } from "../components/DecodeFilter";





import './ScoreDashboard.scss';



import './DecodeHwb.scss';
import { getUnique } from "../../../wip/TableReportMantineV6";
import { WsAppContext } from "../../AppContext";
import { VscHubot } from "react-icons/vsc";
import { AvanadeAiAgent } from "../../AiAgent/AiAgent";








let idCounter = 0;

function useStableId(prefix = 'id') {
  const idRef = React.useRef<string>();

  if (!idRef.current) {
    idCounter += 1;
    idRef.current = `${prefix}-${idCounter}`;
  }

  return idRef.current;
}

const styles = mergeStyleSets({
  button: {
    width: 130,
  },
  callout: {
    width: 320,
    maxWidth: '90%',
    padding: '20px 24px',
  },
  title: {
    marginBottom: 12,
    fontWeight: FontWeights.semilight,
  },
  link: {
    display: 'block',
    marginTop: 20,
  },
});

















const WsScoreRation = (
  props: {
    currentValue: number;
    maxValue:     number;
    scoreView:    WsDecodeScoreView;
  }
) => {

  const [ show, setShow ] = useState<boolean>(true);

  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, process.env.NODE_ENV === 'development' ? 5 * 1000 : 10 * 1000);
  }, []);

  if (show) {

    return (
      <div className="ws-deliver-decode-score-bar-title-ratio">

        {/* {
          process.env.NODE_ENV === 'development'
          &&
          <>[{props.currentValue}]</>
        } */}

        {/* TODO: FIX_CALCULATION */}

        {
          props.currentValue >= 0
          &&
          <>

            {
              props.scoreView === WsDecodeScoreView.Value
              ?
              <>
                {props.currentValue.toFixed(0)}
              </>
              :
              <>
                {
                  props.scoreView === WsDecodeScoreView.Percent
                  ?
                  <>
                    {getMetricValueStringPercent(props.currentValue, props.maxValue)}
                  </>
                  :
                  <>
                    {getMetricValueString(props.currentValue, props.maxValue)}
                  </>
                }
              </>
            }
          </>
        }
      </div>
    );

  } else {
    return (
      <div className="ws-decode-ratio-loading">
        <Loading />
      </div>
    );
  }
};






type WsScoreBarProps = {
  title: string;
  barValue:      number;
  currentValue:  number;
  baselineValue: number;
  index:         number;
  noAnimation?: boolean;
  hideBar?:     boolean;
  showScore?:   boolean;
  scoreView:    WsDecodeScoreView;

  additionalClassName?: string;

};

const WsScoreBar = (props: WsScoreBarProps) =>{

  const [ showBars, setShowBars ] = useState<boolean>(false);

  useEffect(() => {
    setTimeout(() => {
      setShowBars(true);
    }, (props.index === 0 ? 400 : (props.index * 300) + 600));
  }, [ props.index ]);

  // const value = props.baselineValue && props.baselineValue > props.currentValue ? props.currentValue : props.baselineValue;

  return (
    <div className={`ws-deliver-decode-score-bar ${props.additionalClassName || ''}`}>
      {
        (
          props.title
          ||
          props.showScore
        )
        &&
        <div className="ws-deliver-decode-score-bar-title">
          {props.title}
          <WsScoreRation
            currentValue={props.currentValue}
            maxValue={props.baselineValue}
            scoreView={props.scoreView}
          />
        </div>
      }

      {
        props.baselineValue
        ?
        <div className="ws-deliver-decode-score-bar-progress">
          <div className={`ws-deliver-decode-score-bar-total ${props.barValue < 0 && 'ws-deliver-decode-score-bar-total-transparent'}`}></div>
          {
            showBars
            &&
            <div className="ws-deliver-decode-score-bar-value" style={{ width: `${props.barValue}%` }}>
              <div className={`ws-deliver-decode-score-bar-value-fill ws-deliver-decode-score-bar-value-fill-${props.index % 4}`}></div>
            </div>
          }
        </div>
        :
        <></>
      }
    </div>
  );
};









const chartSeries: { [ key: string ]: ApexAxisChartSeries } = {

  'demo': [
    {
      name: "Technology Adoption",
      data: [25, 47, 33, 58, 62, 70],
      color: '#e95d2b'
    },
    {
      name: "Technology Experience",
      data: [55, 40, 60, 75, 75, 90],
      color: '#f4ba40'
    },
    {
      name: "Secure Score",
      data: [40, 65, 40, 67, 70, 80],
      color: '#46d3dd'
    },
    {
      name: "4",
      data: [50, 33, 35, 45, 50, 45],
      color: '#9896f1'
    },
    {
      name: "5",
      data: [20, 22, 29, 25, 35, 30],
      color: '#9896f1'
    },
    {
      name: "6",
      data: [10, 20, 30, 20, 40, 50],
      color: '#be3144'
    },
    {
      name: "7",
      data: [30, 25, 20, 38, 48, 50, 70 ],
      color: '#8fbe25'
    },
    {
      name: "8",
      data: [30, 25, 20, 38, 48, 50, 70 ],
      color: '#0c005a'
    }
  ],

  'teams': [
    {
      name: "Technology Adoption",
      data: [25, 47, 33, 58, 62, 70],
      color: '#e95d2b'
    },
    {
      name: "Technology Experience",
      data: [55, 40, 60, 75, 75, 90],
      color: '#f4ba40'
    },
    {
      name: "Secure Score",
      data: [40, 65, 40, 67, 70, 80],
      color: '#46d3dd'
    }
  ],
  'exchange': [
    {
      name: "Technology Adoption",
      data: [18, 50, 65, 70, 75, 75],
      color: '#e95d2b'
    },
    {
      name: "Technology Experience",
      data: [26, 59, 43, 68, 44, 90],
      color: '#f4ba40'
    },
    {
      name: "Secure Score",
      data: [45, 67, 60, 79, 54, 50],
      color: '#46d3dd'
    }
  ],
  'onedrive': [
    {
      name: "Technology Adoption",
      data: [5, 10, 25, 30, 35, 40],
      color: '#e95d2b'
    },
    {
      name: "Technology Experience",
      data: [22, 31, 30, 60, 48, 55],
      color: '#f4ba40'
    },
    {
      name: "Secure Score",
      data: [2, 14, 20, 22, 26, 51],
      color: '#46d3dd'
    }
  ]
};




const chartOptions: ApexCharts.ApexOptions = {
  tooltip: {
    enabled: false
  },
  chart: {
    toolbar: {
      show: false
    },
    height: 100,
    type: 'line',
    zoom: {
      enabled: false
    }
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    // curve: 'straight'
    curve: 'smooth',
    width: 3
  },
  // title: {
  //   text: 'Score History',
  //   align: 'left'
  // },
  legend: {
    show: false
  },
  grid: {
    row: {
      colors: [
        '#f3f3f3',
        '#f3f3f3',
        // 'transparent'
      ], // takes an array which will be repeated on columns
      opacity: 0.5
    },
  },
  xaxis: {
    categories: [ 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct' ],
    axisTicks: {
      show: false
    },
    labels: {
      show: false
    }
  },
  yaxis: {
    min: 0,
    max: 100,
    // stepSize: 50,
    tickAmount: 2,
    axisTicks: {
      show: false
    },
    labels: {
      show: true
    }
  }
};







type WsScoreChartProps = {
  workload: string;
  metrics: WsDecodeMetric[];
};

const WsScoreChart = (props: WsScoreChartProps) => {

  return (
    <div>
      <div id="chart">
        <ReactApexChart

          options={chartOptions}

          series={props.metrics
            .filter((i) => i.visible)
            .map((metric, index) => {

            const v = chartSeries['demo'];

            // if (v) {
            //   return v;
            // } else {
            //   const x: ApexAxisChartSeries = {
            //     name: '',
            //     data:[ 0, 0, 0, 0, 0 ],
            //     color: '#ffffff'
            //   };
            // }

            // const x: ApexAxisChartSeries = {
            //   // name: '',
            //   // data:[ 0, 0, 0, 0, 0 ],
            //   // color: '#ffffff'
            // };

            // return x;

            return rescueLastMinusTwo(v, index);

          })}
          type="line"
          height={200}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};



const rescueLastMinusTwo = (v: ApexAxisChartSeries, index: number) => {

  if (v[index]) {
    return v[index];
  } else {
    console.warn('series missing!!!');
    console.log('series missing!!!');
    return v[v.length - 1];
  }
};






const WsServiceChart = (props: {}) => {

  const options = { ...chartOptions };

  if (options.chart) {
    options.chart.type = 'area';
    options.chart.height = 250;
  }

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={[
            {
              name: "Score",
              data: [20, 40, 30, 55, 55, 80],
              color: '#e95d2b'
            }
          ]}
          type="area"
          height={250}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};








const barScores = {
  'teams':    [ 0, 70, 90, 80 ],
  'exchange': [ 0, 80, 70, 50 ],
  'onedrive': [ 0, 40, 55, 51 ]
};



type WsScoreCardProps = {
  boardList:   WsDecodeBoardInterface[];
  boardItem:   WsDecodeBoardInterface;
  loadBoards: () => Promise<void>;
  id:          string;
  title:       string;
  description: string;
  workload:    string;
  index:       number;
  metrics: WsDecodeMetric[];
  removeBoard?: () => Promise<void>;
};

const WsScoreCard = (props: WsScoreCardProps) => {

  const history = useHistory();

  const decodeContext = useContext(WsDecodeContext);

  const [ linkBoard, setLinkBoard ] = useState<WsDecodeBoardInterface | undefined>(undefined);

  const [ showChart, setShowChart ] = useState<boolean>(false);

  const [ sourceList, setLabelList ] = useState<WsDecodeSource[] | undefined>(undefined);

  const loadData = useCallback(async () => {

    const result = await apiGet(`/decode/source-list`);

    if (result && Array.isArray(result.sourceList)) {
      const resultData = result.sourceList as WsDecodeSource[];
      // console.log(resultData);
      setLabelList(resultData.filter((item) => !item.deletedAt));
    }

  }, []);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setShowChart(true);
    }, (props.index === 1 ? 2000 : (props.index * 400) + 2000));
  }, [ props.index ]);

  // console.log('======================== props ======');
  // console.log(props);

  // const scores = barScores[props.workload];

  const boardScore = getBoardScorePercent(sourceList, props.boardList, props.id);

  return (
    <div className="ws-deliver-decode-score-block ws-deliver-decode-score-card">

      {
        linkBoard
        &&
        <>
          <WsDecodeLinkBoardDialog
            boardList={props.boardList}
            boardItem={props.boardItem}
            onCancel={() => {
              setLinkBoard(undefined);
            }}
            onSave={async (targetBoard: WsDecodeBoardInterface) => {

              // create

              let newBoardResult = await apiPost(`/decode/boards`, { name: `${linkBoard.name} (Copy)` });

              if (newBoardResult && newBoardResult.boardItem) {

                console.log(newBoardResult.boardItem);

                newBoardResult = await apiPost(`/decode/boards/${newBoardResult.boardItem.id}`, { configuration: linkBoard.configuration });

                // update

                if (!targetBoard.configuration.profiles) {
                  targetBoard.configuration['profiles'] = [];
                }

                targetBoard.configuration.profiles.push({ boardId: newBoardResult.boardItem.id });

                targetBoard.configuration['scoreView'] = WsDecodeScoreView.Score;

                const updateBoardResult = await apiPost(`/decode/boards/${targetBoard.id}`, { configuration: targetBoard.configuration });

                if (updateBoardResult && updateBoardResult.boardItem) {

                  console.log(updateBoardResult.boardItem);

                  // load

                  await props.loadBoards();

                  // navigate

                  history.push(`/deliver/decode/dashboard/${newBoardResult.boardItem.id}`);
                }
              }

              setLinkBoard(undefined);
            }}
          />
        </>
      }

      <ActionButton
        className="ws-decode-copy-board"
        iconProps={{
          iconName: 'Copy'
        }}
        onClick={async () => {
          setLinkBoard(props.boardItem);
        }}
      />

      <ActionButton
        className="ws-decode-delete-board"
        iconProps={{
          iconName: 'Delete'
        }}
        onClick={async () => {

          if (window.confirm(`Delete "${props.title}"?`)) {

            if (props.removeBoard) {
              props.removeBoard();
            }
          }
        }}
      />

      <NavLink className="ws-deliver-decode-score-title" to={`/deliver/decode/dashboard/${props.id}`}>
        <WsDecodeTooltip
          id={`ws-deliver-decode-score-card-tooltip-${props.index}`}
          name={props.title}
          scoreView={props.boardItem.configuration.scoreView}
          content={props.description}
          // card top score
          metricStatistic={{
            convertedValue: getNumericValueBasedOnFilter(boardScore, getUnique(decodeContext)),
            metricValue:    getNumericValueBasedOnFilter(boardScore, getUnique(decodeContext)),
            baselineValue:  100
          }}
        />
      </NavLink>

      {/* <div className="ws-deliver-decode-score-card-action">
        <div className="ws-deliver-decode-score-card-action-label">
          Changes requiring action this month
        </div>
        <div className="ws-deliver-decode-score-card-action-count">
          24
        </div>
      </div> */}

      {
        sourceList
        ?
        <>
          {
            props.metrics.filter((i) => i.visible).length > 0
            ?
            <>

              {/* board card list */}

              <div className="ws-deliver-decode-score-bar-list">
              {
                props.metrics
                .filter((i) => i.visible)
                .map((metric, index) => {

                  const sourceItem = sourceList.find((item) => item.id === metric.sourceId);

                  const metricStatistic = getMetricStatistic(sourceList, props.boardList, metric, sourceItem ? sourceItem.dataValueList : []);



                  // const metricScoreFixed = getMetricScore(metricStatistic, metric.scoreView);
                  // const metricScoreBasedOnFilter = getMetricScoreBasedOnFilter(metricScoreFixed, getUnique(decodeContext));



                  // current value
                  const currentValue              = getMetricStatisticValue(metric, metricStatistic);
                  const currentValueBasedOnFilter = getNumericValueBasedOnFilter(currentValue, getUnique(decodeContext), index);



                  // bar value
                  const barValueBasedOnFilter = getNumericValueBasedOnFilter(metricStatistic.metricValue, getUnique(decodeContext), index);



                  // baseline value
                  const baselineValue = metricStatistic.baselineValue;



                  return (
                    <Fragment key={`ws-metric-bar-${index}`}>
                      <WsScoreBar title={metric.name} // card metric bars
                        key={`ws-metric-bar-${metric.id}`}

                        // currentValue={getNumericValueBasedOnFilter(getMetricStatisticValue(metric, metricStatistic), getUnique(decodeContext))}

                        currentValue={currentValueBasedOnFilter}

                        barValue={barValueBasedOnFilter}
                        
                        baselineValue={baselineValue}

                        index={index}
                        scoreView={metric.scoreView}
                      />
                    </Fragment>
                  );
                })
              }
              </div>
            </>
            :
            <></>
          }
        </>
        :
        <>
          <div className="ws-deliver-decode-score-bar-list">
            <Loading />
            <br />
            <br />
          </div>
        </>
      }

      <div className="ws-deliver-decode-score-card-chart">
        <div className="ws-deliver-decode-score-card-chart-title">Score History</div>
        {
          showChart
          &&
          <WsScoreChart workload={props.workload} metrics={props.metrics} />
        }
      </div>

      <NavLink className="ws-deliver-decode-score-card-footer" to={`/deliver/decode/dashboard/${props.id}`}>
        View Detail
      </NavLink>

      <WsAskAgent className="ws-deliver-decode-score-card-footer decode-ask-agent" />

    </div>
  );
};













const getMetric = (boardMetrics: WsDecodeMetric[], metricId: string): WsDecodeMetric => {

  const findMetric = boardMetrics.find((item) => item.id === metricId);

  if (findMetric) {

    return findMetric;

  } else {

    const newMetric: WsDecodeMetric = {

      parentId: '',
      sourceId: '',

      id:   '',
      name: '',

      measurement:   WsDecodeMeasurement.Average,
      baselineValue: 0,
      weight:        100,

      scoreView: WsDecodeScoreView.Score
    };

    return newMetric;
  }
};




const getMetricSourceName = (metricItem: WsDecodeMetric, sourceList: WsDecodeSource[], boardList: WsDecodeBoardInterface[]) => {

  if (isNumeric(metricItem.sourceId)) {

    const boardItem = boardList.find((item) => item.id === Number(metricItem.sourceId));

    if (boardItem) {
      return `Board (${boardItem.name})`;
    } else {
      return 'Board';
    }

  } else {

    const sourceItem = sourceList.find((item) => item.id === metricItem.sourceId);

    if (sourceItem) {

      const labelItem = getLabelList().find((item) => item.table === sourceItem.dataTable && item.field === sourceItem.dataField);

      if (labelItem) {
        return `${labelItem.source}`;

      } else {
        return 'DECODE';
      }
    } else {
      return 'DECODE';
    }
  }
};




type WsBoardEditProps = {
  boardList: WsDecodeBoardInterface[];
  boardId: string;
  title: string;
  boardMetrics: WsDecodeMetric[];
  setBoardMetrics: React.Dispatch<React.SetStateAction<WsDecodeMetric[]>>;
};

const WsBoardEdit = (props: WsBoardEditProps) => {

  const [ dialogMetricId, setDialogMetricId ] = useState<string>('');



  const decodeContext = useContext(WsDecodeContext);



  const [ sourceList, setLabelList ] = useState<WsDecodeSource[] | undefined>(undefined);

  const loadData = useCallback(async () => {

    const result = await apiGet(`/decode/source-list`);

    if (result && Array.isArray(result.sourceList)) {
      const resultData = result.sourceList as WsDecodeSource[];
      // console.log(resultData);
      setLabelList(resultData.filter((item) => !item.deletedAt));
    }

  }, []);

  useEffect(() => {
    loadData();
  }, []);



  if (sourceList) {

    return (
      <>
        <br />

        <h2 className="title is-4">
          {props.title}
          <ActionButton
            className="ws-decode-add-board"
            iconProps={{
              iconName: 'CircleAddition'
            }}
            style={{
              right: 0
            }}
            onClick={async () => {
              setDialogMetricId('ADD');
            }}
          >
            Add Metric
          </ActionButton>
        </h2>

        <table className="table is-hoverable is-fullwidth ws-decode-metrics-table">
          <thead>
            <tr>
              <th>Included</th>
              <th>Visible</th>
              <th>Name</th>
              <th>Source</th>
              <th>Source Value</th>
              <th>Measurement</th>
              <th>Converted Value</th>
              <th>Weighting</th>
              <th>Value</th>
              <th className="ws-decode-metrics-table-actions"></th>
            </tr>
          </thead>

          <tbody>
            {
              props.boardMetrics.map((metric, index) => {

                const sourceItem = sourceList.find((item) => item.id === metric.sourceId);

                const metricStatistic = getMetricStatistic(sourceList, props.boardList, metric, sourceItem ? sourceItem.dataValueList : []);

                const metricSourceName = getMetricSourceName(metric, sourceList, props.boardList);

                return (
                  <tr key={`ws-decode-metric-${metric.id}`}>
                    <td>
                      <Toggle
                        onText="Yes"
                        offText="No"
                        onChange={(event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                          const nextMetrics = [ ...props.boardMetrics ];

                          if (checked) {
                            metric.active = true;
                          } else {
                            metric.active = false;
                          }

                          props.setBoardMetrics(nextMetrics);
                        }}
                        checked={metric.active ? true : false}
                      />
                    </td>
                    <td>
                      <Toggle
                        onText="Yes"
                        offText="No"
                        onChange={(event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                          const nextMetrics = [ ...props.boardMetrics ];
      
                          if (checked) {
                            metric.visible = true;
                          } else {
                            metric.visible = false;
                          }

                          props.setBoardMetrics(nextMetrics);
                        }}
                        checked={metric.visible ? true : false}
                      />
                    </td>
                    <td>{metric.name}</td>
                    <td>{metricSourceName}</td>
                    <td>{0}</td>
                    <td>{metric.measurement}</td>
                    <td>{metricStatistic.convertedValue.toFixed(1)}</td>
                    <td>{metric.weight}</td>
                    <td>
                      {/* {getMetricValueString(metricStatistic.metricValue, metricStatistic.baselineValue)} */}
                      {getMetricScoreBasedOnFilter(getMetricScore(metricStatistic, metric.scoreView), getUnique(decodeContext))}
                    </td>
                    <td className="ws-decode-metrics-table-actions">
                      <ActionButton
                        // className="ws-decode-edit-board"
                        iconProps={{
                          iconName: 'PageEdit'
                        }}
                        onClick={async () => {
                          setDialogMetricId(metric.id);
                        }}
                      />
                      <ActionButton
                        // className="ws-decode-edit-board"
                        iconProps={{
                          iconName: 'Delete'
                        }}
                        onClick={async () => {
                          const nextMetrics = [ ...props.boardMetrics ].filter((item) => item.id !== metric.id);
                          console.log(nextMetrics);
                          props.setBoardMetrics(nextMetrics);
                        }}
                      />
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>

        <br />
        <br />

        {
          dialogMetricId
          &&
          <>
            <WsDecodeMetricDialog
              boardId={props.boardId}
              metric={getMetric(props.boardMetrics, dialogMetricId)}
              onCancel={() => {
                setDialogMetricId('');
              }}
              onSave={(metric: WsDecodeMetric) => {
                console.log('================================ onSave ==');
                console.log(metric);

                const nextMetrics = [ ...props.boardMetrics ];

                if (metric.id) {

                  console.log('UPDATE METRIC');

                  const findMetric = nextMetrics.find((item) => item.id === metric.id);

                  if (findMetric) {

                    console.log('FOUND METRIC');

                    console.log(findMetric);

                    findMetric.parentId = metric.sourceId;
                    findMetric.sourceId = metric.sourceId;

                    findMetric.name = metric.name;

                    findMetric.staticValue = metric.staticValue || 0;

                    findMetric.measurement   = metric.measurement;
                    findMetric.baselineValue = metric.baselineValue;
                    findMetric.weight        = metric.weight;
                    findMetric.scoreView     = metric.scoreView;

                    findMetric.visible  = metric.visible ? true : false;
                    findMetric.active   = metric.active  ? true : false;
                  }

                } else {

                  console.log('NEW METRIC');

                  metric.id = ulid();

                  nextMetrics.push(metric);

                }

                props.setBoardMetrics(nextMetrics);

                console.log(nextMetrics);

                setDialogMetricId('');
              }}
            />
          </>
        }
      </>
    );

  } else {
    return (
      <>
        <Loading />
        <br />
        <br />
      </>
    );
  }
};















type WsScoreDetailsProps = {
  sourceList: WsDecodeSource[];
  boardList: WsDecodeBoardInterface[];
  setBoardList: React.Dispatch<React.SetStateAction<WsDecodeBoardInterface[] | undefined>>;
  loadBoards: () => Promise<void>;
  title: string;
};

const WsScoreDetails = (props: WsScoreDetailsProps) => {

  const history = useHistory();

  const params: { boardId: string } = useParams();



  const decodeContext = useContext(WsDecodeContext);



  const [ edit, setEdit ] = useState<boolean>(false);

  const [ boardSortingActive, setBoardSortingActive ] = useState<boolean>(false);



  const [ boardName, setBoardName ] = useState<string>('');

  const [ boardDescription, setBoardDescription ] = useState<string>('');

  const [ boardScoreView, setBoardScoreView ] = useState<WsDecodeScoreView>(WsDecodeScoreView.Score);

  const [ boardMetrics, setBoardMetrics ] = useState<WsDecodeMetric[]>([]);



  useEffect(() => {
    setEdit(false);
    setBoardSortingActive(false);
  }, [ params.boardId ]);



  const boardId: string = params.boardId || '1';

  const boardItem = props.boardList.find((item) => item.id === Number(boardId));

  if (boardItem) {

    // console.log(boardItem);
    // console.log(boardScoreView);

    return (
      <div className="ws-deliver-decode-score-details">



        {/* board - title */}

        {
          // boardId !== '1'
          true
          &&
          <>
            <div className="ws-deliver-decode-score-details-title">
              {
                !edit
                &&
                <>
                  {/* <WsDecodeTooltip id={`ws-deliver-decode-score-details-tooltip`} name={boardItem.name} content={getBoardDescription(boardItem) || 'Placeholder - Tooltip...'} /> */}

                  

                  <ActionButton
                    className="ws-decode-edit-board"
                    iconProps={{
                      iconName: 'PageEdit'
                    }}
                    onClick={async () => {
                      setBoardName(boardItem.name);
                      setBoardDescription(boardItem.configuration.description || '');
                      setBoardScoreView(boardItem.configuration.scoreView     || WsDecodeScoreView.Score);
                      setBoardMetrics(boardItem.configuration.metrics         || []);
                      setEdit(true);
                    }}
                  >
                    Edit
                  </ActionButton>

                  {/* <ActionButton
                    className="ws-decode-edit-board"
                    // iconProps={{
                    //   iconName: 'PageEdit'
                    // }}
                    onClick={async () => {
                      // setBoardName(boardItem.name);
                      // setBoardDescription(boardItem.configuration.description || '');
                      // setBoardScoreView(boardItem.configuration.scoreView     || WsDecodeScoreView.Score);
                      // setBoardMetrics(boardItem.configuration.metrics         || []);
                      // setEdit(true);
                    }}
                  >
                    <VscHubot className="decode-ask-agent-icon" />Ask Agent
                  </ActionButton> */}

                  <WsAskAgent className="ws-decode-edit-board" />

                </>
              }

              {
                edit
                &&
                <>
                  {/* Save Board */}

                  <ActionButton
                    className="ws-decode-edit-board"
                    iconProps={{
                      iconName: 'Save'
                    }}
                    onClick={async () => {
                      setEdit(false);

                      const boardConfiguration = { ...boardItem.configuration };

                      boardConfiguration['scoreView'] = boardScoreView;

                      boardConfiguration['description'] = boardDescription;
                      boardConfiguration['metrics']     = boardMetrics;

                      const updateBoardResult = await apiPost(`/decode/boards/${boardItem.id}`, { name: boardName, configuration: boardConfiguration });

                      if (updateBoardResult && updateBoardResult.boardItem) {

                        console.log(updateBoardResult.boardItem);

                        // load

                        await props.loadBoards();

                      }

                      setBoardName('');
                      setBoardDescription('');
                      setBoardMetrics([]);
                    }}
                  >
                    Save
                  </ActionButton>
                </>
              }

            </div>
          </>
        }



        {/* board - read */}

        {
          !edit
          &&
          boardId !== '1'
          &&
          (getBoardMetrics(boardItem).filter((i) => i.visible).length > 0)
          &&
          <>

            {/* metric grid */}

            <div className="ws-deliver-decode-score-details-score-grid ws-deliver-decode-score-details-metric-grid">

              {
                getBoardMetrics(boardItem).filter((i) => i.visible).map((metric, index) => {

                  const sourceItem = props.sourceList.find((item) => item.id === metric.sourceId);

                  const metricStatistic = getMetricStatistic(props.sourceList, props.boardList, metric, sourceItem ? sourceItem.dataValueList : []);



                  // score value
                  const metricScoreFixed         = getMetricScore(metricStatistic, metric.scoreView);
                  const metricScoreBasedOnFilter = getMetricScoreBasedOnFilter(metricScoreFixed, getUnique(decodeContext));



                  // current value
                  const currentValue              = getMetricStatisticValue(metric, metricStatistic);
                  const currentValueBasedOnFilter = getNumericValueBasedOnFilter(currentValue, getUnique(decodeContext));



                  // bar value
                  const barValueBasedOnFilter = getNumericValueBasedOnFilter(metricStatistic.metricValue, getUnique(decodeContext));



                  // baseline value
                  const baselineValue = metricStatistic.baselineValue;



                  return (
                    <div
                      key={`ws-decode-metric-card-${metric.id}`}
                      className="ws-deliver-decode-score-block ws-deliver-decode-score-details-score-item"
                    >
                      <div className="ws-deliver-decode-score-details-score-item-title">{metric.name}</div>
                      <WsScoreBar title="" // board metric bars
                                  additionalClassName="decode-board-metric-bars"

                        currentValue={currentValueBasedOnFilter}
                        
                        barValue={barValueBasedOnFilter}

                        baselineValue={baselineValue}
                        index={1} // bar colour is based on index
                        scoreView={metric.scoreView}
                      />
                      <div className="ws-deliver-decode-score-details-score-item-value">

                        {/* {getMetricValueString(metricStatistic.metricValue, metricStatistic.baselineValue)} */}

                        {/* {
                          process.env.NODE_ENV === 'development'
                          &&
                          <>
                            [{metricScoreFixed} | {metricScoreBasedOnFilter}]
                          </>
                        } */}

                        {/* TODO: FIX_CALCULATION */}

                        {metricScoreBasedOnFilter}

                        {/* {
                          process.env.NODE_ENV === 'development'
                          &&
                          <span style={{ fontSize: 13, marginLeft: 5 }}>
                            | {currentValueBasedOnFilter} | {barValueBasedOnFilter} | {baselineValue} |
                          </span>
                        } */}
                      </div>
                      <NavLink className="ws-deliver-score-item-link" to={`/deliver/decode/dashboard/${boardId}/metrics/${metric.id}`.toLowerCase()}><Icon iconName="NavigateExternalInline" /></NavLink>
                    </div>
                  );
                })
              }

            </div>

            {/* <div className="ws-deliver-decode-score-details-score-grid">
              <div className="ws-deliver-decode-score-block ws-deliver-decode-score-details-score-item">
                Changes requiring action this month
                <div className="" style={{ textAlign: 'center', paddingTop: '20px' }}>
                  <Circle
                    animate={true}
                    animationDuration="1s"
                    bgColor={`${process.env.REACT_APP_WSP_COLOR_BACKGROUND}`}
                    progress={24}
                    progressColor={`${process.env.REACT_APP_WSP_COLOR_GREEN}`}
                    responsive={false}
                    size="150"
                    showPercentageSymbol={false}
                  />
                </div>
              </div>
              <div className="ws-deliver-decode-score-block ws-deliver-decode-score-details-score-item">
                Last Minute Changes
                <div>
                  <table className="table is-striped is-fullwidth">
                    <tbody>
                      <tr><td></td></tr>
                      <tr><td>Change Placeholder</td></tr>
                      <tr><td>Change Placeholder</td></tr>
                      <tr><td>Change Placeholder</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="ws-deliver-decode-score-block ws-deliver-decode-score-details-score-item">
                Risk Level of Scheduled Changes
                <div>
                  <table className="table is-striped is-fullwidth">
                    <thead>
                      <tr><th>Date</th><th>Oct 17</th><th>Oct 11</th></tr>
                    </thead>
                    <tbody>
                      <tr><td>Change Placeholder</td><td>2</td><td>2</td></tr>
                      <tr><td>Change Placeholder</td><td>5</td><td>1</td></tr>
                      <tr><td>Change Placeholder</td><td>1</td><td>1</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> */}

          </>
        }



        {/* board - edit */}

        {
          edit
          &&
          <>

            <br />

            <>

            {
              boardId !== '1'
              &&
              <>

                <div
                  style={{
                    display: 'inline-block',
                    verticalAlign: 'top',
                    width:  300,
                    height: 100
                  }}
                >
                    <TextField
                      label="Name:"
                      // underlined
                      placeholder="Enter Name"
                      onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
                        if (newValue) {
                          setBoardName(newValue);
                        } else {
                          setBoardName('');
                        }
                      }}
                      value={boardName}
                    />
                </div>

                <div
                  style={{
                    display: 'inline-block',
                    verticalAlign: 'top',
                    width:  600,
                    height: 100,
                    marginLeft: 30
                  }}
                >
                  <TextField
                    label="Description:"
                    // underlined
                    placeholder="Enter Description"
                    onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
                      if (newValue) {
                        setBoardDescription(newValue);
                      } else {
                        setBoardDescription('');
                      }
                    }}
                    value={boardDescription}
                  />
                </div>

                <div
                  style={{
                    display: 'inline-block',
                    verticalAlign: 'top',
                    width:  100,
                    height: 100,
                    marginLeft: 30
                  }}
                >
                  <ChoiceGroup
                    label="View"
                    options={[
                      { key: 'SCORE',   text: 'Score'   },
                      { key: 'PERCENT', text: 'Percent' }
                    ]}
                    onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption) => {
                      if (option?.key === 'PERCENT') {
                        setBoardScoreView(WsDecodeScoreView.Percent);
                      } else {
                        setBoardScoreView(WsDecodeScoreView.Score);
                      }
                    }}
                    selectedKey={ boardScoreView === WsDecodeScoreView.Percent ? WsDecodeScoreView.Percent : WsDecodeScoreView.Score }
                  />
                </div>

                <br />
                <br />
                <br />
              </>
              }
            </>

            <WsBoardEdit
              boardList={props.boardList}
              boardId={boardId}
              title="Metrics"
              boardMetrics={boardMetrics}
              setBoardMetrics={setBoardMetrics}
            />
          </>
        }
















        {/* profiles */}

        {
          (
            getBoardProfiles(boardItem).length > 0
            ||
            edit
          )
          &&
          <>
            {/* profiles */}

            {
              // boardItem.id === 1
              true
              &&
              <>
                <div className="ws-deliver-decode-board-profiles">

                  <h2 className="title is-4">
                    Boards

                    {
                      boardSortingActive
                      ?
                      <ActionButton
                        className="ws-decode-sort-boards-button"
                        iconProps={{
                          // iconName: 'BoxAdditionSolid'
                          iconName: 'Save'
                        }}
                        onClick={async () => {

                          setBoardSortingActive(false);

                          console.log(boardItem);

                          boardItem.configuration['profiles'] = getBoardProfiles(boardItem);

                          console.log(boardItem);

                          const updateBoardResult = await apiPost(`/decode/boards/${boardItem.id}`, { configuration: boardItem.configuration });

                          if (updateBoardResult && updateBoardResult.boardItem) {

                            // console.log(updateBoardResult.boardItem);

                            // load

                            await props.loadBoards();

                          }
                        }}
                      >
                        Save Boards
                      </ActionButton>
                      :
                      <ActionButton
                        className="ws-decode-sort-boards-button"
                        iconProps={{
                          // iconName: 'BoxAdditionSolid'
                          iconName: 'Move'
                        }}
                        onClick={async () => {
                          setBoardSortingActive(true);
                        }}
                      >
                        Sort Boards
                      </ActionButton>
                    }

                    <ActionButton
                      className="ws-decode-add-board"

                      iconProps={{
                        // iconName: 'BoxAdditionSolid'
                        iconName: 'AppIconDefaultAdd'
                      }}

                      menuProps={{
                        items: [
                          {
                            key: 'new-board',
                            text: 'New Board',
                            iconProps: { iconName: 'Add' },
                            
                            onClick: () => {

                              setTimeout(async () => {

                                // create new board item

                                const newBoardResult = await apiPost(`/decode/boards`, { name: 'New Profile' });

                                if (newBoardResult && newBoardResult.boardItem) {

                                  console.log(newBoardResult.boardItem);

                                  // update current board item

                                  if (!boardItem.configuration.profiles) {
                                    boardItem.configuration['profiles'] = [];
                                  }

                                  boardItem.configuration.profiles.push({ boardId: newBoardResult.boardItem.id });

                                  boardItem.configuration['scoreView'] = WsDecodeScoreView.Score;

                                  const updateBoardResult = await apiPost(`/decode/boards/${boardItem.id}`, { configuration: boardItem.configuration });

                                  if (updateBoardResult && updateBoardResult.boardItem) {

                                    console.log(updateBoardResult.boardItem);

                                    // load

                                    await props.loadBoards();

                                    // navigate

                                    history.push(`/deliver/decode/dashboard/${newBoardResult.boardItem.id}`);

                                  }
                                }
                              }, 100);
                            }
                          },
                          {
                            key: 'existing-board',
                            text: 'Existing Board',
                            iconProps: { iconName: 'CPlusPlusLanguage' },
                            subMenuProps: {
                              items: (
                                props.boardList
                                .sort((a, b) => {  
                                  if (`${a.name}`.toLowerCase() > `${b.name}`.toLowerCase()) return  1;
                                  if (`${a.name}`.toLowerCase() < `${b.name}`.toLowerCase()) return -1;
                                  return 0;
                                })
                                .filter((item) => {
                                  if (item.id === 1) {
                                    return false;

                                  } else {

                                    if (boardItem.configuration.profiles && Array.isArray(boardItem.configuration.profiles)) {

                                      const filter = boardItem.configuration.profiles.filter((i) => i.boardId === item.id);
                                      if (filter.length > 0) {
                                        return false;
                                      } else {
                                        return true;
                                      }
                                    } else {
                                      return true;
                                    }
                                  }
                                })
                                .map((existingBoardItem, existingBoardItemIndex) => {
                                  return {
                                    key: `existing-board-${existingBoardItemIndex}`,
                                    text: existingBoardItem.name,
                                    iconProps: { iconName: 'CPlusPlusLanguage' },
                                    onClick: () => {

                                      setTimeout(async () => {

                                        // update current board item

                                        if (!boardItem.configuration.profiles) {
                                          boardItem.configuration['profiles'] = [];
                                        }

                                        boardItem.configuration.profiles.push({ boardId: existingBoardItem.id });

                                        boardItem.configuration['scoreView'] = WsDecodeScoreView.Score;

                                        const updateBoardResult = await apiPost(`/decode/boards/${boardItem.id}`, { configuration: boardItem.configuration });

                                        if (updateBoardResult && updateBoardResult.boardItem) {

                                          console.log(updateBoardResult.boardItem);

                                          // load

                                          await props.loadBoards();

                                        }

                                      }, 100);
                                    }
                                  };
                                })
                              )
                            }
                          }
                        ]
                      }}
                    >
                      Add Board
                    </ActionButton>
                  </h2>

                  {
                    boardSortingActive
                    ?
                    <div className="ws-decode-sort-boards">
                      <SortableList
                        onSortEnd={(oldIndex: number, newIndex: number) => {

                          const prevProfileList = getBoardProfiles(boardItem);

                          console.log(prevProfileList);

                          const nextProfileList = arrayMoveImmutable(prevProfileList, oldIndex, newIndex);

                          console.log(nextProfileList);

                          boardItem.configuration['profiles'] = nextProfileList;

                          props.setBoardList((array) => {
                            if (array) {
                              return [ ...array ];
                            } else {
                              return array;
                            }
                          });

                          // props.setBoardList((array) => {
                          //   if (array) {
                          //     console.log(a)
                          //     return arrayMoveImmutable(array, oldIndex, newIndex);
                          //   } else {
                          //     return array;
                          //   }
                          // });

                          // setItems((array) => arrayMove(array, oldIndex, newIndex));

                        }}
                        className="ws-decode-sort-boards-list"
                        draggedItemClassName="dragged"
                      >
                        {getBoardProfiles(boardItem).map((item, index: number) => {
                          // console.log(item);

                          const findBoardItem = props.boardList.find((i) => i.id === item.boardId);

                          return (
                            <SortableItem key={item.boardId}>
                              <div className="ws-decode-sort-boards-item"
                                style={{
                                  backgroundColor: '#fff',
                                  borderRadius: 4,
                                  padding: 20,
                                  boxShadow: '0 4px 8px -2px rgba(9, 30, 66, .25), 0 0 0 1px rgba(9, 30, 66, .08)',
                                  color: 'var(--ws-color-primary)',
                                  fontSize: 16,
                                  fontWeight: 600
                                }}
                              >
                                <div
                                  className="ws-decode-sort-boards-item-block"
                                  style={{
                                    // background: 'red',
                                    // minWidth: 300,
                                    // minHeight: 50
                                  }}
                                >{findBoardItem?.name}</div>
                                <div
                                  className="ws-decode-sort-boards-item-icon"
                                  style={{
                                    textAlign: 'center',
                                    paddingTop: 10
                                  }}
                                >
                                  <Icon
                                    iconName="Move"
                                    style={{
                                      fontSize: 50,
                                      color: '#c1c1c1'
                                    }}
                                  />
                                </div>
                              </div>
                            </SortableItem>
                          );
                        })}
                      </SortableList>
                    </div>
                    :
                    <>
                      <div className="ws-deliver-decode-score-card-grid">
                        {
                          getBoardProfiles(boardItem).map((item, index: number) => {

                            const findBoardItem = props.boardList.find((i) => i.id === item.boardId);

                            if (findBoardItem) {

                              return (
                                <WsScoreCard
                                  key={`ws-score-card-key-${findBoardItem.id}`}
                                  boardList={props.boardList}
                                  loadBoards={props.loadBoards}
                                  boardItem={findBoardItem}
                                  id={`${findBoardItem.id}` || ''}
                                  title={findBoardItem.name}
                                  description={findBoardItem.configuration.description || 'Placeholder - Tooltip...'}
                                  workload="teams"
                                  index={index}
                                  metrics={getBoardMetrics(findBoardItem)}
                                  removeBoard={async () => {

                                    // REMOVE BOARD

                                    console.log(boardItem);

                                    boardItem.configuration['profiles'] = getBoardProfiles(boardItem).filter((item) => `${item.boardId}` !== `${findBoardItem.id}`);

                                    console.log(boardItem);

                                    const updateBoardResult = await apiPost(`/decode/boards/${boardItem.id}`, { configuration: boardItem.configuration });

                                    if (updateBoardResult && updateBoardResult.boardItem) {

                                      // console.log(updateBoardResult.boardItem);

                                      // load

                                      await props.loadBoards();

                                    }
                                  }}
                                />
                              );
                            } else {
                              return (null);
                            }
                          })
                        }
                      </div>
                    </>
                  }
                </div>
              </>
            }
          </>
        }







        {
          !edit
          &&
          <>
            <div className="ws-deliver-decode-score-details-score-grid">
              <div className="ws-deliver-decode-score-block ws-deliver-decode-score-details-score-item" style={{ flex: 'none', width: '754px' }}>
                <div className="ws-deliver-decode-service-title">Score Trend</div>
                <WsServiceChart />
              </div>
              {/* <div className="ws-deliver-decode-score-block ws-deliver-decode-score-details-score-item" style={{ marginRight: 0, width: '364px' }}>
                Change Risk Reduction
                <div className="ws-change-risk-reduction">
                  <div className="ws-change-risk-reduction-value">33%</div>
                  <div className="ws-change-risk-reduction-description">Change Success</div>
                </div>
                <div className="ws-change-risk-reduction">
                  <div className="ws-change-risk-reduction-value ws-red-val-red">11%</div>
                  <div className="ws-change-risk-reduction-description">Incidents associated with change</div>
                </div>
                <div className="ws-change-risk-reduction">
                  <div className="ws-change-risk-reduction-value">5%</div>
                  <div className="ws-change-risk-reduction-description">User downtime associated with change</div>
                </div>
              </div> */}
            </div>
          </>
        }

      </div>
    );

  } else {
    return (null);
  }
};



















const getBoardDataList = (sourceList: WsDecodeSource[], boardList:  WsDecodeBoardInterface[]) => {
  const list: WsWheelItem[] = [];

  const homeBoardItem = boardList.find((item) => item.id === 1);

  if (homeBoardItem && homeBoardItem.configuration.profiles) {

    if (homeBoardItem && homeBoardItem.configuration.profiles && Array.isArray(homeBoardItem.configuration.profiles)) {

      // const cardList = homeBoardItem.configuration.profiles as WsDecodeCard[];

      // cardList.slice(0, 5).forEach((cardItem) => {

      [ 2, // Support
        3, // Performance
        4, // Usage
        6, // Sentiment
        9, // Innovation
      ].forEach((boardId) => {

        const boardItem = boardList.find((item) => item.id === Number(boardId));

        if (boardItem) {

          const boardScore = getBoardScorePercent(sourceList, boardList, `${boardItem.id}`);

          list.push({
            name: boardItem.name,
            score: Number((boardScore / 10).toFixed(1)),
            value: 100
          });
        }
      });
    }
  }

  return list;
};




const getBoardDataListLevel2 = (sourceList: WsDecodeSource[], boardList:  WsDecodeBoardInterface[]) => {

  const list = [ ...dataLevel2 ];


  list.forEach((x) => {

    x.forEach((wheelItem) => {

      const boardItem = boardList.find((item) => item.id === Number(wheelItem.boardId));

      if (boardItem) {

        const metricItem = getBoardMetrics(boardItem).find((item) => `${item.id}`.toLowerCase() === wheelItem.metricId);

        if (metricItem) {

          const sourceItem = sourceList.find((item) => item.id === metricItem.sourceId);

          const metricStatistic = getMetricStatistic(sourceList, boardList, metricItem, sourceItem ? sourceItem.dataValueList : []);

          wheelItem.score = Number((metricStatistic.metricValue / 10).toFixed(1));
        }
      }
    });
  });


  return list;
};



const dataLevel2: WsWheelItem[][] = [

  [
    { name: 'First Contact\nResolution',             score: 100, value: 100, boardId: '2', metricId: '01jb9501ar3jc5a95ebpjtxkbf' },
    { name: 'Mean Time\nTo Resolve',                 score: 100, value: 100, boardId: '2', metricId: '01jb950bs4f4z1tk3scg4yx8jb' },
    { name: 'Proactive\nResolution (%)',             score: 100, value: 100, boardId: '2', metricId: '01jb950rxxhdcyhvf4wz8h0cbs' },
    { name: 'Service\nRequests\nAutomated (%)',      score: 100, value: 100, boardId: '2', metricId: '01jbvb7p4vcxsv8z7b7cncwqe7' },
    { name: 'Ticket\nAvoidance',                     score: 100, value: 100, boardId: '2', metricId: '01jbvb8dg7rkf7wrk1v86gmm5r' }
  ],

  [
    { name: 'Uptime',                                        score: 100, value: 100, boardId: '3', metricId: '01jb9501ar3jc5a95ebpjtxkbf' },
    { name: 'Device\nStartup\nTime',                         score: 100, value: 100, boardId: '3', metricId: '01jb950bs4f4z1tk3scg4yx8jb' },
    { name: 'Device\nExperience\nScore',                     score: 100, value: 100, boardId: '3', metricId: '01jb950rxxhdcyhvf4wz8h0cbs' },
    { name: 'Prod & Collab\nApplication\nExperience Score',  score: 100, value: 100, boardId: '3', metricId: '01jbvbc5fspbx2d79v47t7rgzd' }
  ],

  [
    { name: 'Technology\nAdoption',                     score: 100, value: 100, boardId: '4', metricId: '01jb9501ar3jc5a95ebpjtxkbf' },
    { name: 'Digital\nChannel\nAdoption',               score: 100, value: 100, boardId: '4', metricId: '01jb950bs4f4z1tk3scg4yx8jb' },
    { name: 'Accessible\nFeature\nUsage',               score: 100, value: 100, boardId: '4', metricId: '01jb950rxxhdcyhvf4wz8h0cbs' }
  ],

  [
    { name: 'DWP Net\nPromoter Score',                   score: 100, value: 100, boardId: '6', metricId: '01jb984abx3s73e8zqexa5sqbh' },
    { name: 'Likes',                                     score: 100, value: 100, boardId: '6', metricId: '01jb98469qnsm986r6m3bp8dx4' },
    { name: 'Star Rating',                               score: 100, value: 100, boardId: '6', metricId: '01jb984apa2pj069q40h9ymbw2' },
    { name: 'Sentiment\nFeedback',                       score: 100, value: 100, boardId: '6', metricId: '01jb9a8x2czsv1jn8148pqm7h3' },
    { name: 'Engagement\nFeedback',                      score: 100, value: 100, boardId: '6', metricId: '01jb9845c1rbqw49jrq65868df' }
  ],

  [
    { name: 'Quality\nIdeas\nGenerated',                 score: 100, value: 100, boardId: '9', metricId: '01jbvbk2y9m1t240sc4rgj8xjb' },
    { name: 'Ideas\nExperimented\nPrototyped',           score: 100, value: 100, boardId: '9', metricId: '01jbvbk9vmw4p1qb5fy56eh3wp' },
    { name: 'GenAI & Automation\nStory Point\nVelocity', score: 100, value: 100, boardId: '9', metricId: '01jbvbkpd6p6zrhc8g6agsznar' },
    { name: 'Value\nRealised (ROI)',                     score: 100, value: 100, boardId: '9', metricId: '01jbvbmk50fc3zvrt9tha7n3mm' }
  ]

];





export const getBoardProfiles = (boardItem: WsDecodeBoardInterface) => {
  if (boardItem.configuration.profiles && Array.isArray(boardItem.configuration.profiles) && boardItem.configuration.profiles.length > 0) {
    return boardItem.configuration.profiles as any[];
  } else {
    return [];
  }
};

export const getBoardMetrics = (boardItem: WsDecodeBoardInterface) => {
  if (boardItem.configuration.metrics && Array.isArray(boardItem.configuration.metrics) && boardItem.configuration.metrics.length > 0) {
    return boardItem.configuration.metrics as WsDecodeMetric[];
  } else {
    return [];
  }
};

const getBoardDescription = (boardItem: WsDecodeBoardInterface) => {
  if (boardItem.configuration.description) {
    return boardItem.configuration.description;
  } else {
    return '';
  }
};

const getBoardScore = (boardItem: WsDecodeBoardInterface) => {
  if (boardItem.data.score) {
    return boardItem.data.score;
  } else {
    return 0;
  }
};





const WsAskAgent = (props: { className: string }) => {

  const [ isOpen, setIsOpen ] = React.useState(false);

  const open  = React.useCallback(() => setIsOpen(true),  []);
  const close = React.useCallback(() => setIsOpen(false), []);
  const toggleIsCalloutVisible = React.useCallback(() => setIsOpen(v => !v), []);

  const buttonId = useStableId('callout-button');

  const labelId = useStableId('callout-label');
  const descriptionId = useStableId('callout-description');

  const [ message, setMessage ] = useState<string>('How many new use cases or new ideas have been submitted by NHs Colleagues in the last week?');

  const [ dialog, setDialog ] = useState<string>('');

  return (
    <>
      {
        props.className === 'ws-decode-edit-board'
        ?
        <ActionButton
          id={buttonId}
          className={props.className}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleIsCalloutVisible();
            return false;
          }}
        >
          <VscHubot className="decode-ask-agent-icon" />Ask Agent
        </ActionButton>
        :
        <a
          id={buttonId}
          className={props.className}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleIsCalloutVisible();
            return false;
          }}
          href="#"
        >
          <VscHubot className="decode-ask-agent-icon" />Ask Agent
        </a>
      }

      {/* callout */}

      {
        isOpen
        &&
        (
          <Callout
            className={styles.callout}
            ariaLabelledBy={labelId}
            ariaDescribedBy={descriptionId}
            role="dialog"
            gapSpace={0}
            target={`#${buttonId}`}
            onDismiss={toggleIsCalloutVisible}
            setInitialFocus
          >
            <Text as="h1" block variant="xLarge" className={styles.title} id={labelId}>
              Ask Agent
            </Text>

            <TextField
              multiline rows={5}
              placeholder="Type a message to Agent"
              value={message}
              onChange={(e, val) => {
                if (val) {
                  setMessage(val);
                } else {
                  setMessage('');
                }
              }}
            />

            {/* <Text block variant="small" id={descriptionId}>
              Message body is optional. If help documentation is available, consider adding a link to learn more at the
              bottom.
            </Text> */}

            {/* <Link href="http://microsoft.com" target="_blank" className={styles.link}>
              Sample link
            </Link> */}

            <br />

            <Stack
              // className={styles.buttons}
              gap={8}
              horizontal
              styles={{ root: { width: '100%', justifyContent: 'flex-end' } }}
            >
              <PrimaryButton onClick={() => { setDialog(message); close(); }}>Send</PrimaryButton>
              <DefaultButton onClick={() => {                     close(); }}>Cancel</DefaultButton>
            </Stack>
          </Callout>
        )
      }

      {/* dialog */}

      {
        dialog
        &&
        (
          <Dialog
            hidden={false}
            onDismiss={() => {
              setDialog('');
            }}
            dialogContentProps={{
              title: `Ask Agent`,
              type: DialogType.normal
            }}
            modalProps={{
              className: 'ws-decode-agent-dialog',
              isBlocking: false,
              styles: {
                // main: { width: 700 }
              }
            }}
          >
            <Fragment>
              <div className="ws-decode-agent-dialog-content">
                <AvanadeAiAgent
                  name="DEX Bot"
                  url={ process.env.NODE_ENV === 'production' ? 'https://adp-demo-019cdd35-ai-api.azurewebsites.net/workflow' : 'http://localhost:5050/workflow' }
                  initialMessage={message}
                  isDialog={true}
                />
              </div>
            </Fragment>
            {/* <DialogFooter>
              <>
                <DefaultButton onClick={onClickCancel} text="Cancel" />
                <PrimaryButton onClick={onClickSave}   text="Save" style={{ marginLeft: '4px' }} disabled={(source.name && source.dataSource && source.dataTable && source.dataField) ? false : true} />
              </>
            </DialogFooter> */}
          </Dialog>
        )
      }
    </>
  );
};







const WsDecodeTooltip = (props: { id: string, name: string, scoreView: WsDecodeScoreView, content: string, metricStatistic?: WsMetricStatistic }) => {

  // console.log(props);

  return (
    <>
      <TooltipHost
        className="ws-deliver-decode-board-tooltip"
        content={props.content}
        id={props.id}
        // directionalHint={DirectionalHint.bottomCenter}
        calloutProps={{
          className: 'ws-deliver-decode-board-tooltip-callout',
          style: {
            minWidth: '100px'
          }
        }}
      >
        <BiInfoCircle
          aria-describedby={props.id}
          style={{
            verticalAlign: 'middle',
            // marginRight: '5px',
            // marginTop: '-3px',
            // fontSize: '20px'
          }}
        />
      </TooltipHost>
      {props.name}
      {
        props.metricStatistic
        &&
        <>
          <WsScoreBar title="" // card top score
                      additionalClassName="decode-card-top-score"
            barValue={props.metricStatistic.metricValue}
            currentValue={props.metricStatistic.metricValue}
            baselineValue={props.metricStatistic.baselineValue}
            index={0}
            showScore={true}
            scoreView={props.scoreView}
          />
        </>
      }
    </>
  )
};

















type WsScoreDashboardProps = {
  boardList: WsDecodeBoardInterface[] | undefined;
  setBoardList: React.Dispatch<React.SetStateAction<WsDecodeBoardInterface[] | undefined>>;
  loadBoards: () => Promise<void>;
};

const WsScoreDashboard = (props: WsScoreDashboardProps) => {

  const appContext = useContext(WsAppContext);

  const params: { boardId: string } = useParams();


  const decodeContext = useContext(WsDecodeContext);



  const [ selectedView, setSelectedView ] = useState<string>(
    // 'WHEEL'
    'CARDS'
    // process.env.NODE_ENV === 'development' ? 'WHEEL' : 'CARDS'
  );



  const [ sourceList, setSourceList ] = useState<WsDecodeSource[] | undefined>(undefined);

  const loadData = useCallback(async () => {

    const result = await apiGet(`/decode/source-list`);

    if (result && Array.isArray(result.sourceList)) {
      const resultData = result.sourceList as WsDecodeSource[];
      // console.log(resultData);
      setSourceList(resultData.filter((item) => !item.deletedAt));
    }

  }, []);

  useEffect(() => {
    loadData();
  }, []);



  useEffect(() => {
    // console.log('============ board id changed =============');
    // setSelectedView('WHEEL');
  }, [ params.boardId ]);



  if (props.boardList && sourceList) {

    const boardId: string = params.boardId || '1';

    // console.log(`boardId : ${boardId}`);

    if (boardId !== 'static') {

      const boardItem = props.boardList.find((item) => item.id === Number(boardId));

      if (boardItem) {

        const view = boardItem.id === 1 ? selectedView : 'CARDS';



        const boardScoreOriginalValue = getBoardScorePercent(sourceList, props.boardList, boardId);

        // console.log(boardScore);



        const boardScoreBasedOnFilter = getNumericValueBasedOnFilter(boardScoreOriginalValue, getUnique(decodeContext));



        const classList: string[] = [ 'decode-hwb', 'ws-deliver-decode-score-dashboard' ];

        if (boardItem.id === 1) {
          classList.push('ws-deliver-decode-score-dashboard-main');
        }

        return (
          <div className={classList.join(' ')}>

            {
              [ 'avanade', 'hwb', 'nestle' ].includes(`${appContext?.theme}`)
              &&
              <>
                <WsDecodeFilters
                  defaultValues={{
                    regionalPartnershipId: '',
                    localAuthorityId: '', // 681
                    schoolTypeId: '',
                    schoolId: '', // 6814039
                  }}
                  visible={{
                    DateRange:           true,
                    RegionalPartnership: true,
                    LocalAuthority:      false,
                    SchoolType:          true,
                    School:              false,
                  }}
                />
              </>
            }

            {/* experience */}

            {/* {
              boardItem.id === 1
              &&
              <>
              </>
            } */}



            {/* breadcrumb */}

            {
              // boardItem.id !== 1
              true
              &&
              <div className="ws-deliver-decode-breadcrumb">
                <WsBreadcrumb boardList={props.boardList} />
              </div>
            }



            {/* top score bar */}

            <div className="ws-deliver-decode-score-block ws-deliver-decode-top-bar">
              <div className="ws-deliver-decode-score-title">
                <WsDecodeTooltip
                  id={`ws-deliver-decode-board-tooltip-${1}`}
                  name={boardItem.id === 1 ? 'Digital Experience Score' : boardItem.name}
                  scoreView={boardItem.configuration.scoreView}
                  content={`Placeholder -Tooltip...`}
                />
                <div className="ws-deliver-decode-score-value">
                  {
                    boardScoreBasedOnFilter >= 0
                    &&
                    <>
                      {
                        boardItem.configuration.scoreView === WsDecodeScoreView.Percent
                        ?
                        getMetricValueStringPercent(boardItem.id === 1 ? boardScoreBasedOnFilter : boardScoreBasedOnFilter, 10)
                        :
                        getMetricValueString(boardItem.id === 1 ? boardScoreBasedOnFilter : boardScoreBasedOnFilter, 10)
                      }
                    </>
                  }
                </div>
              </div>
              <WsScoreBar title="" // board top score
                          additionalClassName="decode-board-top-score"
                // currentValue={boardItem.id === 1 ? boardScore * 10 : boardScore}
                currentValue={boardScoreBasedOnFilter}
                barValue={boardScoreBasedOnFilter}
                baselineValue={10}
                index={0}
                scoreView={WsDecodeScoreView.Score}
              />
            </div>



            {/* {
              boardItem.id === 1
              &&
              <>
                <div
                  className="tabs is-toggle"
                  style={{
                    marginTop: 20,
                    marginBottom: 0,
                    position: 'relative',
                    zIndex: 1000
                  }}
                >
                  <ul>
                    <li className={ selectedView === 'WHEEL' ? 'is-active' : '' }>
                      <a onClick={() => {
                        setSelectedView('WHEEL');
                      }}>
                        <span>DEX 360</span>
                      </a>
                    </li>
                    <li className={ selectedView === 'CARDS' ? 'is-active' : '' }>
                      <a onClick={() => {
                        setSelectedView('CARDS');
                      }}>
                        <span>Dashboard</span>
                      </a>
                    </li>
                    <li className={ selectedView === 'REPORTS' ? 'is-active' : '' }>
                      <a onClick={() => {
                        setSelectedView('REPORTS');
                      }}>
                        <span>Digital Maturity Reports</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </>
            } */}



            {
              // process.env.NODE_ENV === 'development'
              true
              ?
              <>
                {/* {
                  view === 'WHEEL'
                  &&
                  <WsWheelRecharts

                    overallScore={boardScoreBasedOnFilter}

                    // sourceList={sourceList}
                    // boardList={props.boardList}

                    data={getBoardDataList(sourceList, props.boardList)}

                    dataLevel2={getBoardDataListLevel2(sourceList, props.boardList)}

                    // compact={true}
                  />
                } */}

                {
                  view === 'CARDS'
                  &&
                  <WsScoreDetails
                    sourceList={sourceList}
                    boardList={props.boardList}
                    setBoardList={props.setBoardList}
                    loadBoards={props.loadBoards}
                    title={boardItem.name}
                  />
                }

                {
                  view === 'REPORTS'
                  &&
                  <>
                    <Loading />
                    <div style={{ textAlign: 'center' }}>
                      Indexing of Data in Progress...
                    </div>
                  </>
                }
              </>
              :
              <>
                <Loading />
                <div style={{ textAlign: 'center' }}>
                  Indexing of Data in Progress...
                </div>
              </>
            }

          </div>
        );

      } else {
        return (<>Board not found!</>);
      }

    } else {    

      return (
        <div className="ws-deliver-decode-score-dashboard">
        </div>
      );
    }

  } else {

    return (
      <>
        <Loading/>
      </>
    );
  }
};














type WsServiceDashboardProps = {
  data?: any[];
};

const WsServiceDashboard = (props: WsServiceDashboardProps) => {

  return (
    <div className="ws-deliver-decode-score-dashboard">

      <div className="ws-deliver-decode-service ws-deliver-decode-score-details">
        {/* <div className="ws-deliver-decode-score-details-title">
          {workloadNames[params.workload]}
        </div> */}

        <div className="ws-deliver-decode-score-block ws-deliver-decode-score-details-score-item">
          <div className="ws-deliver-decode-service-title">Cumulative risk reduction</div>


          <div style={{ display: 'flex'}}>

            <div className="ws-change-risk-reduction">
              <div className="ws-change-risk-reduction-value" style={{ paddingTop: '100px' }}>12%</div>
              {/* <div className="ws-change-risk-reduction-description">Change Success</div> */}
            </div>

            <div style={{ flexGrow: 1 }}>
              <WsServiceChart />
            </div>
          </div>
        </div>

        <br />

        <div className="ws-deliver-decode-score-details-score-grid">
          <div className="ws-deliver-decode-score-block ws-deliver-decode-score-details-score-item">
            <div className="ws-deliver-decode-service-title">Annual saving from reduced failure rates</div>
            {/* <div className="ws-deliver-decode-score-details-score-item-title">Technology Adoption</div> */}
            <div className="ws-service-savings">&#163;100.11</div>
            <NavLink className="ws-deliver-decode-score-card-footer" to={`/deliver/decode/service`}>View Detail</NavLink>
          </div>
          <div className="ws-deliver-decode-score-block ws-deliver-decode-score-details-score-item">
            <div className="ws-deliver-decode-service-title">Productivity benefits</div>
            {/* <div className="ws-deliver-decode-score-details-score-item-title">Technology Experience</div> */}
            <div className="ws-service-savings">&#163;100.11</div>
            <NavLink className="ws-deliver-decode-score-card-footer" to={`/deliver/decode/service`}>View Detail</NavLink>
          </div>
          <div className="ws-deliver-decode-score-block ws-deliver-decode-score-details-score-item">
            <div className="ws-deliver-decode-service-title">IT workload savings</div>
            {/* <div className="ws-deliver-decode-score-details-score-item-title">Security Score</div> */}
            <div className="ws-service-savings">72 hours</div>
            <NavLink className="ws-deliver-decode-score-card-footer" to={`/deliver/decode/service`}>View Detail</NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};






const WsTriage = (props: {}) => {

  return (
    <div className="ws-deliver-decode-score-dashboard ws-decode-insight-page">
      <br />
      <br />

      <div className="ws-deliver-decode-score-card-grid">
        {
          getInsightList().map((insightItem, insightIndex) => {


            return (
              <div
                key={`ws-decode-insight-item-key-${insightIndex}`}
                className="ws-deliver-decode-score-block ws-deliver-decode-score-card"
              >

                <div className="ws-deliver-decode-score-title">{insightItem.name}</div>

                <div className="ws-deliver-decode-insight-block">
                  <div className="ws-deliver-decode-insight-block-title">Finding</div>
                  <div className="ws-deliver-decode-insight-block-text">{insightItem.finding}</div>
                </div>

                <div className="ws-deliver-decode-insight-block">
                  <div className="ws-deliver-decode-insight-block-title">Recommendation</div>
                  <div className="ws-deliver-decode-insight-block-text">{insightItem.recommendation}</div>
                </div>


                <div className="ws-deliver-decode-insight-block">
                  <div className="ws-deliver-decode-insight-block-title">Found by</div>
                  <div className="ws-deliver-decode-insight-block-text">{insightItem.foundBy}</div>
                </div>

              </div>
            );
          })
        }
      </div>
    </div>
  );
};




interface WsDecodeInsight {
  name:           string;
  finding:        string;
  recommendation: string;
  foundBy:        string;
}

const getInsightList = (): WsDecodeInsight[] => {

  return [
    {
      name:           'Profiles',
      finding:        'Office worker profile contains >80% of total user count.',
      recommendation: 'The profile should be sub-divided into additional profiles to allow for more granular monitoring.',
      foundBy:        'Rule: Profile Averages'
    },
    {
      name: 'Teams Calls',
      finding:        'Teams Calls with large numbers of participants occur at a rate above average, reducing productive time.',
      recommendation: 'A change program should be implemented to enable people to better qualify meeting invitations.',
      foundBy:        'Machine Learning'
    },
    {
      name: 'CoPilot',
      finding:        'Marketing Department has below average Copilot utilization.',
      recommendation: 'A change program should be run to increase the adoption of Copilot in the marketing department to drive greater efficiency and ROI.',
      foundBy:        'Rule: Product Adoption'
    },
    {
      name: 'Hardware',
      finding:        'Devices greater than 36 months old are having a significant performance impact on users.',
      recommendation: 'Hardware greater than 36 months should be replaced, recycled or repurposed.',
      foundBy:        'Machine Learning'
    },
    {
      name: 'Sustainability',
      finding:        'Not all devices are using efficient power modes',
      recommendation: 'Implement efficient power modes and automated shutdown for devices with no usage out of regular business hours.',
      foundBy:        'Rule: Sustainability - Endpoint Power utilization'
    },
    {
      name: 'Aged Data',
      finding:        'Travel Procedures SharePoint site contains aged data that has not been accessed or updated for over 12 months.',
      recommendation: 'Review this site and data, retire obsolete data and sites.',
      foundBy:        'Rule: Aged Data'
    }
  ]
};










{/* <div className="ws-deliver-decode-triage-legend">
  <div className="ws-deliver-decode-triage-legend-label">Business Value Key:</div>
  <div className="ws-deliver-decode-triage-legend-low">LOW</div>
  <div className="ws-deliver-decode-triage-legend-high">HIGH</div>
</div> */}

// <div style={{ padding: '0 30px' }}>
//   <Shimmer />
//   <br />
//   <Shimmer width="80%" />
//   <br />
//   <Shimmer width="60%" />
//   <br />
//   <Shimmer width="40%" />
//   <br />
//   <br />
//   <br />
// </div>

/*
  // this function will generate output in this format
  // every array in data is of the format [x, y, z] where x (timestamp) and y are the two axes coordinates,
  // z is the third coordinate, which you can interpret as the size of the bubble formed too.
  // data = [
     [timestamp, 23, 10],
     [timestamp, 33, 11],
     [timestamp, 12, 8]
      ...
  ]
*/

function generateData(baseval, count, yrange) {
  var i = 0;
  var series: any[] = [];
  while (i < count) {
    var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;;
    var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
    var z = Math.floor(Math.random() * (75 - 15 + 1)) + 80;

    series.push([x, y, z]);
    baseval += 86400000;
    i++;
  }
  return series;
}
  
  


{/* <div style={{ marginLeft: -10 }}>
      <div id="chart">
        <ReactApexChart
          options={{

            tooltip: {
              enabled: true,
              x: {
                show: false
              },
              y: {
                title: {
                  formatter(seriesName) {
                    return '';
                  },
                }
              },
              z: {
                title: 'Action',
                formatter(val) {
                  return '';
                },
              }
            },

            chart: {
              toolbar: {
                show: false
              },
              height: 500,
              type: 'bubble',
              zoom: {
                enabled: false
              }
            },
            dataLabels: {
              enabled: false
            },
            fill: {
              opacity: 0.8
            },
            // title: {
            //     text: 'Simple Bubble Chart'
            // },
            legend: {
              show: false
            },
            xaxis: {
              tickAmount: 1,
              min: 0,
              max: 750,
              // stepSize: 380,
              type: 'category',
              labels: {
                show: false
              }
            },
            yaxis: {
              tickAmount: 1,
              max: 100,
              labels: {
                show: false
              }
            },
            markers: {
              strokeWidth: 1
            }
          }}
          series={[{
            name: 'Bubble1',
            data: generateData(new Date('11 Feb 2017 GMT').getTime(), 10, {
              min: 10,
              max: 100
            }),
            color: '#8f1c74'
          },
          {
            name: 'Bubble2',
            data: generateData(new Date('11 Feb 2017 GMT').getTime(), 10, {
              min: 10,
              max: 100
            }),
            color: '#b4354a'
          },
          {
            name: 'Bubble3',
            data: generateData(new Date('11 Feb 2017 GMT').getTime(), 10, {
              min: 10,
              max: 100
            }),
            color: '#d64e2f'
          },
          {
            name: 'Bubble4',
            data: generateData(new Date('11 Feb 2017 GMT').getTime(), 10, {
              min: 10,
              max: 100
            }),
            color: '#eb5f2a'
          }]}
          type="bubble"
          height={500}
        />
      </div>
      <div id="html-dist"></div>
    </div> */}





export {
  WsServiceDashboard,
  WsScoreDashboard,
  WsTriage
};
